<template>
  <div class="bi-control-panel-tab bi-parameter-rules-tab">
    <BIParameterRulesFilter />

    <div class="bi-parameter-rules-toolbar d-flex justify-end pr-5 pb-2">
      <v-btn
        v-if="canEdit"
        color="primary"
        elevation="0"
        style="height: 42px; border-radius: 6px;"
        @click="openCreateForm"
      >
        <v-icon left size="18">mdi-plus-circle-outline</v-icon>
        {{ $t('biControlPanel.parameterRules.table.newRule') }}
      </v-btn>
    </div>

    <BIParameterRulesTable
      :can-edit="canEdit"
      @edit="openEditForm"
      @rule-history="showRuleHistory"
      @parameter-history="showParameterHistory"
    />

    <HistoryModal ref="HistoryModal" :history="historyEntries" :identity-columns="historyIdentityColumns" />
    <SnackbarCustomize ref="SnackbarCustomize" />
  </div>
</template>

<script>
import BIParameterRulesFilter from '@/components/BIControlPanel/BIParameterRulesFilter.vue';
import BIParameterRulesTable from '@/components/BIControlPanel/BIParameterRulesTable.vue';
import HistoryModal from '@/components/Modals/HistoryModal/HistoryModal.vue';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import BiPanelRuleModule from '@/store/modules/bi-panel-rule/bi-panel-rule-module';

export default {
  name: 'BIParameterRulesTab',
  components: {
    BIParameterRulesFilter,
    BIParameterRulesTable,
    HistoryModal,
    SnackbarCustomize,
  },
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { historyMode: null };
  },
  computed: {
    history() {
      return BiPanelRuleModule.history;
    },
    historyEntries() {
      if (this.historyMode === 'rule') return this.history.rule;
      if (this.historyMode === 'parameter') return this.history.parameter;

      return [];
    },
    historyIdentityColumns() {
      return [
        {
          text: this.$t('biControlPanel.parameterRules.table.levelType'),
          value: 'levelLabel',
          sortable: false,
          width: 130,
          class: 'col-history-level',
          cellClass: 'col-history-level',
        },
      ];
    },
  },
  mounted() {
    const { errorMessage } = this.$route.params;

    if (errorMessage) {
      this.showError(errorMessage);
    }

    this.runStoreAction(
      BiPanelRuleModule.initializeTab(),
      this.translate('biControlPanel.parameterRules.messages.loadError'),
    );
  },
  methods: {
    openCreateForm() {
      this.$router.push({ name: 'BIPanelRuleForm', query: { mode: 'create' } });
    },
    openEditForm(row) {
      this.$router.push({
        name: 'BIPanelRuleForm',
        query: { mode: 'edit', ruleId: String(row.ruleId) },
      });
    },
    async showRuleHistory(row) {
      this.historyMode = 'rule';
      const result = await this.runStoreAction(
        BiPanelRuleModule.fetchRuleHistory(row),
        this.translate('biControlPanel.parameterRules.messages.historyLoadError'),
      );

      if (result && result.success !== false) {
        this.$refs.HistoryModal.open();
      }
    },
    async showParameterHistory(row) {
      this.historyMode = 'parameter';
      const result = await this.runStoreAction(
        BiPanelRuleModule.fetchParameterHistory(row),
        this.translate('biControlPanel.parameterRules.messages.historyLoadError'),
      );

      if (result && result.success !== false) {
        this.$refs.HistoryModal.open();
      }
    },
    translate(key) {
      return this.$t(key).toString();
    },
    showError(message) {
      this.$refs.SnackbarCustomize.open('error', message);
    },
    async runStoreAction(actionPromise, fallbackMessage) {
      const result = await actionPromise;

      if (result && result.success === false) {
        this.showError(result.errorMessage || fallbackMessage);
      }

      return result;
    },
  },
};
</script>
